export interface DecoderType {
  id: number
  index: number
  interfaceId: number
  address: number
  name: string
  decoderTypeId: number
  decoderType: string
  configurationId: number
  configuration: string
  typeId: number
  type: string
  configStateId: number
  configState: string
  attention: number
  value: number
  locationId: number
}

export interface ConfigurationType {
  id: number
  description: ConfigurationType[]
  flags: number
  luTypeProtocolMask: number
  ioTypeMask: number
  config: string
  expression: string
  interfaceId: number
}

export interface ConfigurationSetupType {
  id: number
  description: string
  flags: number
  luTypeProtocolMask: number
  ioTypeMask: number
  config: string
  expression: string
  interfaceId: number
}

export interface DecoderSetupType {
  id: number
  name: string
}

export enum OutputDecoderType {
  IRRIGATION = 1,
  FERTIGATION = 2,
  FILTRATION = 3,
  PUMP_START = 4,
  MV_NORMALLY_OPEN = 5,
  MV_NORMALLY_CLOSED = 6,
  BOOSTER_PUMP = 7,
}

export interface DecoderSwitchParameters {
  inrush: number
  inrushTime: number
  hold: number
}

export interface DecoderReading {
  value: string
  rawValue: number
  switchParameters: DecoderSwitchParameters | null
  resistance: number | null
  inductance: number | null
}